import { FollowupSelect } from "./FollowupSelect";

export default FollowupSelect;
